/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Replace_EllipsesInputs */



/**
* | output |
* | --- |
* | "Replace ..+ with Ellipses" |
*
* @param {Replace_EllipsesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const replace_ellipses = /** @type {((inputs?: Replace_EllipsesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Replace_EllipsesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Remplacer ..+ par des points de suspension")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ersetzen Sie ..+ durch Auslassungspunkte.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sostituisci ..+ con ellissi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Замените ..+ многоточием.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reemplazar ..+ con puntos suspensivos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将 ..+ 替换为省略号")
	if (locale === "ja") return /** @type {LocalizedString} */ ("..+ を省略記号に置き換える")
	if (locale === "hi") return /** @type {LocalizedString} */ ("..+ को एलिप्सिस से बदलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Substitua ..+ por reticências")
	return /** @type {LocalizedString} */ ("Replace ..+ with Ellipses")
});